import React from 'react';
import Badge from '../ui/Badge';

const kpis = [
  { id: 'total', label: 'Total Incidents', valueKey: 'total' },
  { id: 'open', label: 'Open', valueKey: 'open' },
  { id: 'critical', label: 'Critical', valueKey: 'critical' },
  { id: 'followUps', label: 'Follow-ups Required', valueKey: 'followUps' },
  { id: 'overdue', label: 'Overdue Follow-ups', valueKey: 'overdueFollowUps' }
];

export default function IncidentsKpis({ counts, activeKpi, onSelect }) {
  return (
    <div className="sp-kpi-grid" role="tablist" aria-label="Incident KPIs">
      {kpis.map((kpi) => {
        const value = counts[kpi.valueKey] ?? 0;
        const isActive = activeKpi === kpi.id;
        return (
          <button
            key={kpi.id}
            type="button"
            className={`sp-kpi-card ${isActive ? 'sp-kpi-card--active' : ''}`}
            onClick={() => onSelect?.(kpi.id)}
            aria-pressed={isActive}
          >
            <div className="sp-kpi-label">{kpi.label}</div>
            <div className="sp-kpi-value">{value}</div>
            {kpi.id === 'overdue' && value > 0 && (
              <Badge variant="danger">Action needed</Badge>
            )}
          </button>
        );
      })}
    </div>
  );
}
